import URL from 'url-parse';

/*
  Wrapper for URL class from the url-parse module. Provides additional functionalities
  commonly used in Raven. We should try to use it in all url construction areas.

  Functionalities:
  - handles both absolute / relative URLs by default
      new Url('https://pewsa100:8443/webshop/endpoint').toString() => 'https://pewsa100:8443/webshop/endpoint
      new Url('/webshop/endpoint').toString() => '/webshop/endpoint'

  - does not encode commas into %2C

  - allows to filter query parameters

  - allows to chain methods
    new Url('/webshop/endpoint')
        .addQueryParameter('key1', 'value1')
        .addQueryParameters(externalParameters)
        .whitelistQueryParameters(['key1', 'key2', 'key3'])
        .toString()
*/
export default class Url extends URL {
  constructor(urlString, origin = '/') {
    super(urlString, origin, true);
  }

  addQueryParameters(queryParameters) {
    this.set('query', {
      ...this.query,
      ...queryParameters,
    });
    return this;
  }

  addQueryParameter(key, value) {
    return this.addQueryParameters({ [key]: value });
  }

  filterQueryParameters(filter) {
    const filteredQuery = Object.keys(this.query).reduce((acc, key) => {
      if (filter(key, this.query[key])) {
        acc[key] = this.query[key];
      }
      return acc;
    }, {});

    this.set('query', filteredQuery);
    return this;
  }

  whitelistQueryParameters(whitelist) {
    return this.filterQueryParameters((key) => whitelist.indexOf(key) >= 0);
  }

  blacklistQueryParameters(blacklist) {
    return this.filterQueryParameters((key) => blacklist.indexOf(key) === -1);
  }

  toString() {
    const urlString = URL.prototype.toString.call(this);
    return urlString.replace(/%2C/g, ',');
  }
}
